import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import Page from 'src/components/Page';
import avatar from 'src/assets/images/technician.png';

const styles = {
  root: (theme) => ({
    padding: theme.spacing(3),
    paddingTop: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
  }),
  imageContainer: (theme) => ({
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }),
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  },
  buttonContainer: (theme) => ({
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  })
};

function Error404() {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page
      sx={styles.root}
      title="Error 404"
    >
      <Typography
        align="center"
        variant={mobileDevice ? 'h4' : 'h1'}
      >
        Aradığınız Sayfa Bulunamadı!..
      </Typography>
      <Typography
        align="center"
        variant="subtitle2"
      >
        Apollo giriş sayfasına aşağıdaki buton ile ulaşabilirsiniz
      </Typography>
      <Box sx={styles.imageContainer}>
        <img
          alt="Under development"
          style={styles.image}
          src={avatar}
        />
      </Box>
      <Box sx={styles.buttonContainer}>
        <Button
          color="primary"
          component={RouterLink}
          to="/"
          variant="outlined"
        >
         apollo Sistemi Giriş
        </Button>
      </Box>
    </Page>
  );
}

export default Error404;
